export default __webpack_public_path__ + "static/media/ok.8e568b8c.svg";